import React from 'react';
import { getAchievementStatus } from '../utils/teamPerformanceUtils.ts';

interface PerformanceSummaryProps {
  totalTargetSales: number;
  totalActualSales: number;
  achievementRate: number;
  userRole?: string;
  userTeamName?: string | null;
  // 🆕 근무일/일평균 통계
  totalWorkingDays?: number;
  totalDailyAverageSales?: number;
}

const PerformanceSummary: React.FC<PerformanceSummaryProps> = React.memo(({
  totalTargetSales,
  totalActualSales,
  achievementRate,
  userRole,
  userTeamName,
  totalWorkingDays,
  totalDailyAverageSales
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
      <h2 className="text-lg font-medium text-gray-700 mb-4">
        {userRole === 'employee' && userTeamName ? `${userTeamName} 팀 매출 요약` : '전체 매출 요약'}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">목표 매출</h3>
          <p className="text-2xl font-semibold text-gray-900 tabular-nums">
            {totalTargetSales.toLocaleString()}원
          </p>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">실제 매출</h3>
          <p className="text-2xl font-semibold text-gray-900 tabular-nums">
            {totalActualSales.toLocaleString()}원
          </p>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">달성률</h3>
          <div className="flex items-baseline space-x-2">
            <p className="text-2xl font-semibold text-gray-900 tabular-nums">
              {achievementRate.toFixed(1)}%
            </p>
            {totalTargetSales > 0 && (
              <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${getAchievementStatus(achievementRate / 100).chipClass}`}>
                {getAchievementStatus(achievementRate / 100).label}
              </span>
            )}
          </div>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">근무일</h3>
          <p className="text-2xl font-semibold text-gray-900 tabular-nums">
            {totalWorkingDays ?? 0}일
          </p>
        </div>
        <div className="border border-gray-200 p-4 rounded-lg">
          <h3 className="text-sm font-medium text-gray-600">일평균 매출</h3>
          <p className="text-2xl font-semibold text-gray-900 tabular-nums">
            {(totalDailyAverageSales ?? 0).toLocaleString()}원
          </p>
        </div>
      </div>
    </div>
  );
});

PerformanceSummary.displayName = 'PerformanceSummary';

export default PerformanceSummary; 